<template>
  <!-- Importing UnAuthorized Component -->
  <UnAthorizedPage></UnAthorizedPage>
</template>
<script>
import UnAthorizedPage from "../../components/Error/UnAuthorized.vue";

export default {
  name: "UnAthorized",
  components: { UnAthorizedPage },
  computed: {},
  mounted() {},
};
</script>
